const SvgUpArrowGrey = (props) => {
	return (
		<svg
			width="10"
			height="6"
			viewBox="0 0 10 6"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M5.00095 0.150306C4.82173 0.150306 4.64253 0.218736 4.50589 0.355309L0.206118 4.65513C-0.0674039 4.92865 -0.0674039 5.37212 0.206118 5.64553C0.479529 5.91894 0.922909 5.91894 1.19645 5.64553L5.00095 1.84081L8.80547 5.64539C9.07899 5.91881 9.52232 5.91881 9.79571 5.64539C10.0694 5.37198 10.0694 4.92852 9.79571 4.65499L5.49601 0.355175C5.3593 0.218581 5.1801 0.150306 5.00095 0.150306Z"
				fill="#999999"
			/>
		</svg>
	);
};

export default SvgUpArrowGrey;
